import { useQuery } from '@tanstack/react-query';
import { fetchCartCheckoutProducts } from './apiFetchCartCheckoutProducts';
import { useDispatch } from 'react-redux';
import { AxiosError } from 'axios';
import { ProductSearchResponseOut } from '../../../../../store/api';
import { Pagination } from '../../../../../../models/Pagination';
import { typedFailure } from '../../../../checkout/utils/request-error';
import { PATH_CART } from '../../../../../store/constants';

const CART_CHECKOUT_PRODUCTS_QUERY = 'cartCheckoutProducts';

export const useCartCheckoutProducts = (pagination: Pagination) => {
    const dispatch = useDispatch();

    return useQuery<ProductSearchResponseOut, AxiosError>(
        [CART_CHECKOUT_PRODUCTS_QUERY, pagination],
        () => fetchCartCheckoutProducts(pagination),
        {
            onError: error => {
                dispatch(typedFailure(error, PATH_CART));
            }
        }
    );
};
